/** @file Curve-graph metrics in screen pixels; the pick tolerance is editor-geometry HANDLE_PX.point. */

/** Ruler strip, key and handle sizes, curve sampling step and cap, tick spacing, fit padding, box threshold. */
export const CURVE_GRAPH = { rulerPx: 18, keyPx: 3.5, handlePx: 3, samplePx: 2, maxSamples: 1024, minTickPx: 48, fitPadPx: 24, boxMinPx: 3 } as const;
